





























































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import {
  VQuery,
  VTable,
  QueryModel,
  TableHander,
  TableOperation
} from '@/components/table'
import { QueryConfigLIst, UpdateOrSaveSysConfigByParam, QueryCouponTemplateList } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { Message, MessageBox } from 'element-ui'
import { VImageUpload } from '@/components/upload'

type SysConfig = {
  title: string
  configParam: string
  configValue: any
  note: string
}

@Component({
  components: {
    VImageUpload
  }
})
export default class SysConfigList extends Vue {
  private activeName = 'kf'
  private couponTemplateOptions: any[] = []
  private param: any = {
    kfQC: {
      title: '客服二维码',
      configParam: 'kfQC',
      configValue: '',
      note: ''
    },
    buyGxRate: {
      title: '自购贡献值获取比例(%)',
      configParam: 'buyGxRate',
      configValue: 0,
      note: 'ps: 用于计算用户购买商品时获得的贡献值'
    },
    buyNlRate: {
      title: '自购能量值获取比例(%)',
      configParam: 'buyNlRate',
      configValue: 0,
      note: 'ps: 用于计算用户购买商品时获得的能量值'
    },
    ldOffsetRate: {
      title: '绿豆抵扣金额（元）',
      configParam: 'ldOffsetRate',
      configValue: 0.01,
      note: 'ps: 1绿豆抵扣N的现金'
    },
    autoCancelOrderTime: {
      title: '订单自动取消时间(分钟)',
      configParam: 'autoCancelOrderTime',
      configValue: 30,
      note: 'ps: 未支付订单将在N分钟之后自动取消，配置0表示不设置自动取消'
    },
    autoFinishOrderDay: {
      title: '订单自动完成时间（天）',
      configParam: 'autoFinishOrderDay',
      configValue: 7,
      note: 'ps: 物流状态为已签收后，N天订单自动完成从'
    },
    platformServiceFeeRate: {
      title: '平台手续费%',
      configParam: 'platformServiceFeeRate',
      configValue: 1,
      note: 'ps: 每笔订单将自动扣出平台手续费'
    },
    settlementCycle: {
      title: '结算周期（天）',
      configParam: 'settlementCycle',
      configValue: 15,
      note: 'ps:  订单完成后，X天商家收益结算入账（入账后商家可提现）'
    },
    distributionActivityRate: {
      title: '单次奖励池比例（%）',
      configParam: 'distributionActivityRate',
      configValue: 20,
      note: 'ps: 默认值为 20%，修改后下次执行活动生效， 在绿豆活动中，如果活动类型是百分比的形式时，单次分红获取的数量为：pv*绿豆管理比例（%）*绿豆管理中的百分比'
    },
     partnerThreshould: {
      title: '合伙人分红阈值',
      configParam: 'partnerThreshould',
      configValue: 10000,
      note: 'ps: 默认值为 10000， 在绿豆活动中，合伙人贡献值和能量值低于阈值，不扣除合伙人贡献值和能量值'
    },
    distributionOrderActiveDays: {
      title: '分红活跃下单天数（天）',
      configParam: 'distributionOrderActiveDays',
      configValue: 0,
      note: 'ps: 0=关闭；>0 时近 N 天内 shop_id=100009 支付成功且已确认收货视为活跃，用于定时分红实发比例'
    },
    distributionOrderActiveRatio: {
      title: '满足条件分红分配比例（%）',
      configParam: 'distributionOrderActiveRatio',
      configValue: 100,
      note: 'ps: 活跃用户的定时分红实发 = 原应发 × 本比例 ÷ 100'
    },
    distributionOrderInactiveRatio: {
      title: '不满足条件分红分配比例（%）',
      configParam: 'distributionOrderInactiveRatio',
      configValue: 100,
      note: 'ps: 非活跃用户的定时分红实发 = 原应发 × 本比例 ÷ 100；未发出差额留平台 PV'
    },
    shopInviteRate: {
      title: '店铺推荐获取比例（%）',
      configParam: 'shopInviteRate',
      configValue: 1,
      note: 'ps: 默认值为 1,, 在订单购买中, 非直营的店铺通过这个比例*订单pv给店铺推荐人分发绿豆'
    },
    provinceRate: {
      title: '省代绿豆比例（%）',
      configParam: 'provinceRate',
      configValue: 1,
      note: 'ps: 默认值为 1,, 在订单购买中, 匹配订单省区域通过这个比例*订单pv给省代分发绿豆'
    },
    cityRate: {
      title: '市代绿豆比例（%）',
      configParam: 'cityRate',
      configValue: 1,
      note: 'ps: 默认值为 1,, 在订单购买中, 匹配订单市区域通过这个比例*订单pv给市代分发绿豆'
    },
    districtRate: {
      title: '区代绿豆比例（%）',
      configParam: 'districtRate',
      configValue: 1,
      note: 'ps: 默认值为 1,, 在订单购买中, 匹配订单区域通过这个比例*订单pv给区代分发绿豆'
    },
    pRate: {
      title: '区代绿豆比例（%）',
      configParam: 'pRate',
      configValue: 1,
      note: ''
    },
    pRate2: {
      title: '区代绿豆比例（%）',
      configParam: 'pRate2',
      configValue: 1,
      note: ''
    },
    pRate3: {
      title: '区代绿豆比例（%）',
      configParam: 'pRate3',
      configValue: 1,
      note: ''
    },
    pDate1: {
      title: '区代绿豆比例（%）',
      configParam: 'pDate1',
      configValue: 1,
      note: ''
    },
    pDate2: {
      title: '区代绿豆比例（%）',
      configParam: 'pDate2',
      configValue: 1,
      note: ''
    },
    payChannel: {
      title: '支付通道',
      configParam: 'payChannel',
      configValue: "llpay",
      note: 'ps: 连连支付-llpay,汇付支付-huifu（H5/支付宝等；小程序微信现金看下方「小程序微信现金通道」）'
    },
    payCashMerchantWxXcx: {
      title: '小程序微信现金通道',
      configParam: 'payCashMerchantWxXcx',
      configValue: 'llpay',
      note: 'zhilian=微信官方APIv3直连只做收款；llpay=回滚连连。仅影响小程序微信现金（含混合现金段）'
    },
    payCashMerchantAppWx: {
      title: 'APP微信现金通道',
      configParam: 'payCashMerchantAppWx',
      configValue: 'llpay',
      note: '一期固定 llpay；二期才可改 zhilian'
    },
    maxPaymentDiscount: {
      title: '最高支付立减金额（元）',
      configParam: 'maxPaymentDiscount',
      configValue: "0.5",
      note: 'ps: 单笔订单，最高支付立减金额（元），默认0.5元'
    },
    jkyOrderPushEnabled: {
      title: '吉客云订单推送',
      configParam: 'jkyOrderPushEnabled',
      configValue: '0',
      note: '开启后向吉客云推送订单及售后/变更通知，关闭则不推送；默认关闭'
    },
    distributionMonthlyRepurchaseRemindEnabled: {
      title: '分销每月复购首页提醒',
      configParam: 'distributionMonthlyRepurchaseRemindEnabled',
      configValue: '0',
      note: '开启后：自下方「提醒起始日」至月末，用户本月未下分销商品（已支付）单时，C端首页每日弹窗提醒一次'
    },
    distributionMonthlyRepurchaseRemindStartDay: {
      title: '分销每月复购提醒起始日',
      configParam: 'distributionMonthlyRepurchaseRemindStartDay',
      configValue: '20',
      note: '每月从该日（含）至月末；1～31，默认 20'
    },
    pickupAutoConfirmReceiptEnabled: {
      title: '自提超时自动确认收货',
      configParam: 'pickupAutoConfirmReceiptEnabled',
      configValue: '0',
      note: '开启后已确认的自提单支付成功超过配置天数未核销则自动确认收货；每日00:07执行'
    },
    pickupAutoConfirmReceiptDays: {
      title: '自提自动确认收货天数',
      configParam: 'pickupAutoConfirmReceiptDays',
      configValue: '7',
      note: '自然日，自 success_pay_time 起算；仅 order_status=已确认 的自提单；建议1～90'
    },
    invitationUrl: {
      title: '邀请连接',
      configParam: 'invitationUrl',
      configValue: "https://sc-h5.chengyingshengwu.com/#/pages/register",
      note: 'PS：改连接用于前端，邀请用户时，查看邀请二维码时，拼接邀请连接时使用，会在后面加inviteCode'
    },
    goodsSharePosterBgImage: {
      title: '商品分享海报背景图',
      configParam: 'goodsSharePosterBgImage',
      configValue: '',
      note: '1242×2582 竖版 JPG/PNG，最多 3 张逗号分隔'
    },
    goodsShareUrlPrefix: {
      title: '商品分享 H5 链接前缀',
      configParam: 'goodsShareUrlPrefix',
      configValue: '',
      note: '示例 https://sc-h5.xxx/#/pages/goods/goodsDescV2；空则 C 端按 userInviteUrl 推导'
    },
    activityPaySuccessActivityRatio: {
      title: '支付成功活跃度系数',
      configParam: 'activityPaySuccessActivityRatio',
      configValue: '0',
      note: '商品订单支付成功：活跃度=订单实际支付金额(元)×系数；系数建议0.1～10，填0或不配置表示不发'
    },
    activityQtyPurchaseGoods: {
      title: '购买商品支付成功奖励活跃度(已废弃)',
      configParam: 'activityQtyPurchaseGoods',
      configValue: '0',
      note: '已由「支付成功活跃度系数」按实付×系数发放，此项仅保留兼容旧数据'
    },
    activityQtyInviterOnRegister: {
      title: '邀请新用户注册给邀请人活跃度',
      configParam: 'activityQtyInviterOnRegister',
      configValue: '0',
      note: '被邀请人注册成功给邀请人；0 不发'
    },
    couponGrantInviteeOnRegister: {
      title: '注册发券(被邀请人)',
      configParam: 'couponGrantInviteeOnRegister',
      configValue: '0',
      note: '新用户注册成功发券；存优惠券模板ID，0表示不发'
    },
    couponGrantInviterOnRegister: {
      title: '注册发券(邀请人)',
      configParam: 'couponGrantInviterOnRegister',
      configValue: '0',
      note: '被邀请人注册成功给邀请人发券；存模板ID，0表示不发'
    },
    activityQtyOrderConfirmReceipt: {
      title: '订单确认收货奖励活跃度',
      configParam: 'activityQtyOrderConfirmReceipt',
      configValue: '0',
      note: '买家确认收货；0 不发'
    },
    activityQtyWatchLive: {
      title: '看直播奖励活跃度(预留)',
      configParam: 'activityQtyWatchLive',
      configValue: '0',
      note: 'way_type=6，本系统暂不自动发，供直播程序对接参考'
    },
    llpayWxPayServiceRate: {
      title: '支付手续费率（连连-微信）（‰）',
      configParam: 'llpayWxPayServiceRate',
      configValue: "6.5",
      note: 'PS：XX（‰）,单位为千分制，会在支付成功时，计算支付手续费，公式为 实际支付金额*费率，保留到分，多余的小数四舍五入'
    },
    llpayAliPayServiceRate: {
      title: '支付手续费（连连-支付宝）（‰）',
      configParam: 'llpayAliPayServiceRate',
      configValue: "6",
      note: 'PS：XX（‰）,单位为千分制，会在支付成功时，计算支付手续费，公式为 实际支付金额*费率，保留到分，多余的小数四舍五入'
    },
    // mengBeanPayServiceRate: {
    //   title: '支付手续费（绿豆）（‰）',
    //   configParam: 'mengBeanPayServiceRate',
    //   configValue: "0",
    //   note: 'PS：XX（‰）,单位为千分制，会在支付成功时，计算支付手续费，公式为 实际支付金额*费率，保留到分，多余的小数四舍五入'
    // },
    mung_bean_allocate_ten_gen_ratio_1: {
      title: '分配充值-十代第1代比例(%)',
      configParam: 'mung_bean_allocate_ten_gen_ratio_1',
      configValue: '10',
      note: '分配型绿豆充值十代比例'
    },
    mung_bean_allocate_ten_gen_ratio_2: {
      title: '分配充值-十代第2代比例(%)',
      configParam: 'mung_bean_allocate_ten_gen_ratio_2',
      configValue: '10',
      note: '分配型绿豆充值十代比例'
    },
    mung_bean_allocate_ten_gen_ratio_3: {
      title: '分配充值-十代第3代比例(%)',
      configParam: 'mung_bean_allocate_ten_gen_ratio_3',
      configValue: '10',
      note: '分配型绿豆充值十代比例'
    },
    mung_bean_allocate_ten_gen_ratio_4: {
      title: '分配充值-十代第4代比例(%)',
      configParam: 'mung_bean_allocate_ten_gen_ratio_4',
      configValue: '10',
      note: '分配型绿豆充值十代比例'
    },
    mung_bean_allocate_ten_gen_ratio_5: {
      title: '分配充值-十代第5代比例(%)',
      configParam: 'mung_bean_allocate_ten_gen_ratio_5',
      configValue: '10',
      note: '分配型绿豆充值十代比例'
    },
    mung_bean_allocate_ten_gen_ratio_6: {
      title: '分配充值-十代第6代比例(%)',
      configParam: 'mung_bean_allocate_ten_gen_ratio_6',
      configValue: '10',
      note: '分配型绿豆充值十代比例'
    },
    mung_bean_allocate_ten_gen_ratio_7: {
      title: '分配充值-十代第7代比例(%)',
      configParam: 'mung_bean_allocate_ten_gen_ratio_7',
      configValue: '10',
      note: '分配型绿豆充值十代比例'
    },
    mung_bean_allocate_ten_gen_ratio_8: {
      title: '分配充值-十代第8代比例(%)',
      configParam: 'mung_bean_allocate_ten_gen_ratio_8',
      configValue: '10',
      note: '分配型绿豆充值十代比例'
    },
    mung_bean_allocate_ten_gen_ratio_9: {
      title: '分配充值-十代第9代比例(%)',
      configParam: 'mung_bean_allocate_ten_gen_ratio_9',
      configValue: '10',
      note: '分配型绿豆充值十代比例'
    },
    mung_bean_allocate_ten_gen_ratio_10: {
      title: '分配充值-十代第10代比例(%)',
      configParam: 'mung_bean_allocate_ten_gen_ratio_10',
      configValue: '10',
      note: '分配型绿豆充值十代比例'
    },
    special_price_ten_gen_ratio_1: {
      title: '特价十代第1代比例(%)',
      configParam: 'special_price_ten_gen_ratio_1',
      configValue: '10',
      note: '特价商品十代比例'
    },
    special_price_ten_gen_ratio_2: {
      title: '特价十代第2代比例(%)',
      configParam: 'special_price_ten_gen_ratio_2',
      configValue: '10',
      note: '特价商品十代比例'
    },
    special_price_ten_gen_ratio_3: {
      title: '特价十代第3代比例(%)',
      configParam: 'special_price_ten_gen_ratio_3',
      configValue: '10',
      note: '特价商品十代比例'
    },
    special_price_ten_gen_ratio_4: {
      title: '特价十代第4代比例(%)',
      configParam: 'special_price_ten_gen_ratio_4',
      configValue: '10',
      note: '特价商品十代比例'
    },
    special_price_ten_gen_ratio_5: {
      title: '特价十代第5代比例(%)',
      configParam: 'special_price_ten_gen_ratio_5',
      configValue: '10',
      note: '特价商品十代比例'
    },
    special_price_ten_gen_ratio_6: {
      title: '特价十代第6代比例(%)',
      configParam: 'special_price_ten_gen_ratio_6',
      configValue: '10',
      note: '特价商品十代比例'
    },
    special_price_ten_gen_ratio_7: {
      title: '特价十代第7代比例(%)',
      configParam: 'special_price_ten_gen_ratio_7',
      configValue: '10',
      note: '特价商品十代比例'
    },
    special_price_ten_gen_ratio_8: {
      title: '特价十代第8代比例(%)',
      configParam: 'special_price_ten_gen_ratio_8',
      configValue: '10',
      note: '特价商品十代比例'
    },
    special_price_ten_gen_ratio_9: {
      title: '特价十代第9代比例(%)',
      configParam: 'special_price_ten_gen_ratio_9',
      configValue: '10',
      note: '特价商品十代比例'
    },
    special_price_ten_gen_ratio_10: {
      title: '特价十代第10代比例(%)',
      configParam: 'special_price_ten_gen_ratio_10',
      configValue: '10',
      note: '特价商品十代比例'
    },

  }
  private imageValue: any = {
    kfQcImageList: [],
    goodsSharePosterBgImageList: [],
  }

  private tableData: Array<any> = []

  /** 十代比例表单项（绑定 param 中 mung_bean_allocate_ten_gen_ratio_*） */
  get tenGenRatioRows(): Array<{ genNo: number; configParam: string; label: string; item: SysConfig }> {
    const rows: Array<{ genNo: number; configParam: string; label: string; item: SysConfig }> = []
    for (let i = 1; i <= 10; i++) {
      const configParam = `mung_bean_allocate_ten_gen_ratio_${i}`
      if (!this.param[configParam]) {
        this.$set(this.param, configParam, {
          title: `分配充值-十代第${i}代比例(%)`,
          configParam,
          configValue: '10',
          note: '分配型绿豆充值十代比例',
        })
      }
      rows.push({
        genNo: i,
        configParam,
        label: `第${i}代比例(%)`,
        item: this.param[configParam],
      })
    }
    return rows
  }

  get specialPriceTenGenRatioRows(): Array<{ genNo: number; configParam: string; label: string; item: SysConfig }> {
    const rows: Array<{ genNo: number; configParam: string; label: string; item: SysConfig }> = []
    for (let i = 1; i <= 10; i++) {
      const configParam = `special_price_ten_gen_ratio_${i}`
      if (!this.param[configParam]) {
        this.$set(this.param, configParam, {
          title: `特价十代第${i}代比例(%)`,
          configParam,
          configValue: '10',
          note: '特价商品十代比例',
        })
      }
      rows.push({
        genNo: i,
        configParam,
        label: `第${i}代比例(%)`,
        item: this.param[configParam],
      })
    }
    return rows
  }

  get specialPriceTenGenRatioSum(): string {
    let sum = 0
    for (let i = 1; i <= 10; i++) {
      const key = `special_price_ten_gen_ratio_${i}`
      const item = this.param[key]
      if (item && item.configValue !== '' && item.configValue != null) {
        sum += parseFloat(String(item.configValue)) || 0
      }
    }
    return sum.toFixed(2)
  }

  get tenGenRatioSum(): string {
    let sum = 0
    for (let i = 1; i <= 10; i++) {
      const key = `mung_bean_allocate_ten_gen_ratio_${i}`
      const item = this.param[key]
      if (item && item.configValue !== '' && item.configValue != null) {
        sum += parseFloat(String(item.configValue)) || 0
      }
    }
    return sum.toFixed(2)
  }

  get distributionMonthlyRepurchaseRemindStartDayNum(): number {
    const item = this.param.distributionMonthlyRepurchaseRemindStartDay
    const n = parseInt(String(item && item.configValue != null ? item.configValue : '20'), 10)
    if (Number.isNaN(n)) {
      return 20
    }
    return Math.min(31, Math.max(1, n))
  }

  set distributionMonthlyRepurchaseRemindStartDayNum(val: number) {
    if (this.param.distributionMonthlyRepurchaseRemindStartDay) {
      this.param.distributionMonthlyRepurchaseRemindStartDay.configValue = String(val)
    }
  }

  private async onDistributionMonthlyRepurchaseRemindStartDayChange(val: number) {
    if (val == null || val < 1 || val > 31) {
      Message.warning('提醒起始日须为 1～31')
      return
    }
    const day = Math.round(val)
    this.distributionMonthlyRepurchaseRemindStartDayNum = day
    await this.updateConfig(this.param.distributionMonthlyRepurchaseRemindStartDay)
  }

  get pickupAutoConfirmReceiptDaysNum(): number {
    const item = this.param.pickupAutoConfirmReceiptDays
    const n = parseInt(String(item && item.configValue != null ? item.configValue : '7'), 10)
    if (Number.isNaN(n)) {
      return 7
    }
    return Math.min(90, Math.max(1, n))
  }

  set pickupAutoConfirmReceiptDaysNum(val: number) {
    if (this.param.pickupAutoConfirmReceiptDays) {
      this.param.pickupAutoConfirmReceiptDays.configValue = String(val)
    }
  }

  private async onPickupAutoConfirmReceiptDaysChange(val: number) {
    if (val == null || val < 1 || val > 90) {
      Message.warning('自提自动确认天数须为 1～90')
      return
    }
    const day = Math.round(val)
    this.pickupAutoConfirmReceiptDaysNum = day
    await this.updateConfig(this.param.pickupAutoConfirmReceiptDays)
  }

  get couponGrantInviteeTemplateId(): number | undefined {
    return this.parseCouponGrantTemplateId(this.param.couponGrantInviteeOnRegister?.configValue)
  }

  get couponGrantInviterTemplateId(): number | undefined {
    return this.parseCouponGrantTemplateId(this.param.couponGrantInviterOnRegister?.configValue)
  }

  private parseCouponGrantTemplateId(raw: any): number | undefined {
    if (raw == null || raw === '' || raw === '0') {
      return undefined
    }
    const s = String(raw).trim()
    const colon = s.indexOf(':')
    const idPart = colon > 0 ? s.substring(0, colon).trim() : s
    const n = parseInt(idPart, 10)
    return Number.isNaN(n) || n <= 0 ? undefined : n
  }

  private couponTemplateOptionLabel(t: any): string {
    if (!t) {
      return ''
    }
    const name = t.name || ''
    return name ? `${name}（ID:${t.id}）` : `模板ID:${t.id}`
  }

  private async loadCouponTemplateOptions(): Promise<void> {
    this.couponTemplateOptions = (await QueryCouponTemplateList({ enabledOnly: true })) || []
  }

  private async onCouponGrantInviteeChange(val: number | null | undefined): Promise<void> {
    const item = this.param.couponGrantInviteeOnRegister
    if (!item) {
      return
    }
    item.configValue = val != null && val > 0 ? String(val) : '0'
    await this.updateConfig(item)
  }

  private async onCouponGrantInviterChange(val: number | null | undefined): Promise<void> {
    const item = this.param.couponGrantInviterOnRegister
    if (!item) {
      return
    }
    item.configValue = val != null && val > 0 ? String(val) : '0'
    await this.updateConfig(item)
  }

  public async created() {
    await Promise.all([this.loadCouponTemplateOptions(), this.loadData()])
  }

  public async loadData() {
    const param = {}
    const result = await QueryConfigLIst(param)
    this.tableData = result.list
    //  匹配参数
    this.tableData.forEach((e) => {
      // 将列表转换为对象格式
      if (!this.param[e.configParam]) {
        this.param[e.configParam] = {
          title: e.title,
          configParam: e.configParam,
          configValue: e.configValue,
          note: e.note
        }
      } else {
        this.param[e.configParam].title = e.title
        this.param[e.configParam].configParam = e.configParam
        this.param[e.configParam].configValue = e.configValue
        this.param[e.configParam].note = e.note
      }

      //  特殊处理
      if (e.configParam === 'jkyOrderPushEnabled') {
        const v = e.configValue
        this.param.jkyOrderPushEnabled.configValue =
          v === 1 || v === '1' || v === true ? '1' : '0'
      }
      if (e.configParam === 'distributionMonthlyRepurchaseRemindEnabled') {
        const v = e.configValue
        this.param.distributionMonthlyRepurchaseRemindEnabled.configValue =
          v === 1 || v === '1' || v === true ? '1' : '0'
      }
      if (e.configParam == 'kfQC') {
        this.imageValue.kfQcImageList = e.configValue
          .split(',')
          .map((e: string) => {
            return { url: e }
          })
      }
      if (e.configParam === 'goodsSharePosterBgImage' && e.configValue) {
        this.imageValue.goodsSharePosterBgImageList = e.configValue
          .split(',')
          .filter((u: string) => u)
          .map((u: string) => ({ url: u }))
      }
    })
    this.ensureTenGenRatioParams()
    this.ensureSpecialPriceTenGenRatioParams()
  }

  private ensureSpecialPriceTenGenRatioParams() {
    for (let i = 1; i <= 10; i++) {
      const configParam = `special_price_ten_gen_ratio_${i}`
      if (!this.param[configParam]) {
        this.$set(this.param, configParam, {
          title: `特价十代第${i}代比例(%)`,
          configParam,
          configValue: '10',
          note: '特价商品十代比例',
        })
      }
    }
  }

  private async onSpecialPriceTenGenRatioChange(data: SysConfig) {
    const sum = parseFloat(this.specialPriceTenGenRatioSum)
    if (Math.abs(sum - 100) > 0.001) {
      Message.warning(`当前特价十代比例合计为 ${this.specialPriceTenGenRatioSum}%，须调整为 100% 后再保存`)
    }
    await this.updateConfig(data)
    await this.loadData()
  }

  private ensureTenGenRatioParams() {
    for (let i = 1; i <= 10; i++) {
      const configParam = `mung_bean_allocate_ten_gen_ratio_${i}`
      if (!this.param[configParam]) {
        this.$set(this.param, configParam, {
          title: `分配充值-十代第${i}代比例(%)`,
          configParam,
          configValue: '10',
          note: '分配型绿豆充值十代比例',
        })
      }
    }
  }

  private async onTenGenRatioChange(data: SysConfig) {
    const sum = parseFloat(this.tenGenRatioSum)
    if (Math.abs(sum - 100) > 0.001) {
      Message.warning(`当前十代比例合计为 ${this.tenGenRatioSum}%，须调整为 100% 后再保存`)
    }
    await this.updateConfig(data)
    await this.loadData()
  }

  private async qcChange(list: Array<any>) {
    if (!list || list.length == 0) {
      return
    }
    this.imageValue.kfQcImageList = list
    if (list && list.length > 0) {
      this.param.kfQC.configValue = list[0].url
    } else {
      this.param.kfQC.configValue = ''
    }
    this.updateConfig(this.param.kfQC)
  }

  private async goodsSharePosterBgChange(list: Array<any>) {
    this.imageValue.goodsSharePosterBgImageList = list || []
    if (!this.param.goodsSharePosterBgImage) {
      this.$set(this.param, 'goodsSharePosterBgImage', {
        title: '商品分享海报背景图',
        configParam: 'goodsSharePosterBgImage',
        configValue: '',
        note: '1242×2582 竖版 JPG/PNG，最多 3 张逗号分隔',
      })
    }
    this.param.goodsSharePosterBgImage.configValue = (list || [])
      .map((item) => item.url)
      .filter((url: string) => url)
      .join(',')
    await this.updateConfig(this.param.goodsSharePosterBgImage)
  }

  private async onPayCashMerchantWxXcxChange(val: string) {
    this.param.payCashMerchantWxXcx.configValue = val
    await this.updateConfig(this.param.payCashMerchantWxXcx)
  }

  private async onPayCashMerchantAppWxChange(val: string) {
    this.param.payCashMerchantAppWx.configValue = val
    await this.updateConfig(this.param.payCashMerchantAppWx)
  }

  private async updateConfig(data: SysConfig) {
    const res = await UpdateOrSaveSysConfigByParam(data)
    return res
  }
}
